import React from 'react';
import DepreciationReport from './DepreciationReport';

const DepreciationConsolidatedReport = () => {
  return <DepreciationReport type="consolidated-report" />;
};

export default DepreciationConsolidatedReport;
